// Helper functions
export const extractSegments = (leg) => {
  if (!leg) return [];
  if (Array.isArray(leg)) {
    return leg.filter((s) => s && s.flightNo);
  }
  if (typeof leg === "object") {
    const values = Object.values(leg);
    return values.filter((s) => s && s.flightNo);
  }
  return [];
};

export const calculateTotalDuration = (leg) => {
  if (!leg) return 0;
  if (leg.durTotal) return Number(leg.durTotal);
  const segs = extractSegments(leg);
  return segs.reduce((sum, s) => sum + Number(s.duration || 0), 0);
};

export const calculateStopsText = (leg) => {
  const segs = extractSegments(leg);
  const stops = Math.max(0, segs.length - 1);
  if (stops === 0) return "Non-stop";
  const vias = segs
    .slice(0, -1)
    .map((s) => s.arrCode)
    .join(", ");
  return `${stops} Stop${stops > 1 ? "s" : ""}${vias ? ` via ${vias}` : ""}`;
};

// Process API fare options into display format
export const processFareOptions = (apiFares, flightData, type) => {
  if (!apiFares || !Array.isArray(apiFares)) return [];

  return apiFares.map((fare, index) => {
    const isStandard = fare.fareName?.includes("Standard") || fare.fareTypeDesc?.toLowerCase().includes("standard");
    const isPremium = fare.fareName?.includes("Premium") || fare.fareTypeDesc?.toLowerCase().includes("premium");
    const isMeal = fare.fareName?.includes("Meal") || fare.fareTypeDesc?.toLowerCase().includes("meal");

    let color = "blue";
    if (isStandard) color = "blue";
    else if (isPremium) color = "green";
    else if (isMeal) color = "purple";

    // V2: Extract fare type information
    const fareTypeInd = fare.fareTypeInd;
    const fareTypeDesc = fare.fareTypeDesc || fare.fareName || "";
    const popMsg = fare.popMsg || "";

    // V2: Extract SSR information if available
    const ssrInfo = fare.ssrInfo || null;
    const baggageOptions = ssrInfo?.Bagg || [];
    const mealOptions = ssrInfo?.Meal || [];

    return {
      id: `${type}-${index}`,
      name: fare.fareName || fareTypeDesc || "Standard Fare",
      price: typeof fare.price === "string" ? parseInt(fare.price) : fare.price,
      base: fare.base || fare.basePrice || "0",
      tax: fare.tax || fare.taxAmount || "0",
      refundable: fare.refundable || fare.refundType === "P" ? "Partially Refundable*" : "Non-Refundable",
      baggage: fare.baggage?.checkin || fare.baggage || "0 KG",
      dateChangeFee: fare.dateChangeFee || "Contact Airlines",
      meals: fare.meals || "Paid",
      seats: fare.seats || "Paid",
      color: color,
      type: type,
      flightData: flightData,
      apiFare: fare, // Keep original API data
      baggageDetail: fare.baggage,
      cancellationFee: fare.cancellationFee || "4,275",
      // V2: Add fare type information
      fareTypeInd: fareTypeInd,
      fareTypeDesc: fareTypeDesc,
      popMsg: popMsg,
      // V2: Add SSR information
      ssrInfo: ssrInfo,
      baggageOptions: baggageOptions,
      mealOptions: mealOptions,
    };
  });
};

// Helper function to extract airline name from segments
export const extractAirlineName = (segments) => {
  if (!segments || segments.length === 0) return "Airline";
  const firstSegment = segments[0];
  return firstSegment?.airName || "Airline";
};